module.exports = __webpack_public_path__ + "img/spotters.5d99ca5d.png";